import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const CreateAddonModal = ({ show, handleClose, handleCreate }) => {
    const [addonName, setAddonName] = useState('');
    const [modules, setModules] = useState([{ nom: '', prix: '' }]);

    const handleModuleChange = (index, event) => {
        const { name, value } = event.target;
        const values = [...modules];
    
        if (name === "prix") {
            const formattedValue = parseFloat(value).toFixed(2);
            values[index][name] = formattedValue;
        } else {
            values[index][name] = value;
        }
    
        setModules(values);
    };
    

    const handleAddModule = () => {
        setModules([...modules, { nom: '', prix: '' }]);
    };

    const handleRemoveModule = (index) => {
        const values = [...modules];
        values.splice(index, 1);
        setModules(values);
    };

    const handleSubmit = () => {
        const newAddon = {
            nom: addonName,
            modules: modules
        };
        handleCreate(newAddon);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Créer un nouvel addon</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="addonName">
                        <Form.Label>Nom de l'addon</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nom de l'addon"
                            value={addonName}
                            onChange={(e) => setAddonName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Label>Modules</Form.Label>
                    {modules.map((module, index) => (
                        <div key={index} className="d-flex mb-2">
                            <Form.Control
                                type="text"
                                name="nom"
                                placeholder="Nom du module"
                                value={module.nom}
                                onChange={(event) => handleModuleChange(index, event)}
                                className="mr-2"
                            />
                            <Form.Control
                                type="number"
                                name="prix"
                                placeholder="Prix en €"
                                value={module.prix}
                                onChange={(event) => handleModuleChange(index, event)}
                                className="mr-2"
                                   min="0"
                            />
                            {modules.length > 1 && (
                                <Button variant="danger" onClick={() => handleRemoveModule(index)}>
                                   <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            )}
                        </div>
                    ))}
                    <Button className="mt-3" onClick={handleAddModule}>Ajouter un module</Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Annuler</Button>
                <Button variant="primary" onClick={handleSubmit}>Créer</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateAddonModal;
